const userProfile = {
  title: 'My profile',
  tabs: {
    about: 'About me',
    settings: 'Settings'
  }
}

export default userProfile
